import { render, staticRenderFns } from "./AccountDashboardInformation.vue?vue&type=template&id=3539c148&"
import script from "./AccountDashboardInformation.vue?vue&type=script&lang=ts&"
export * from "./AccountDashboardInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3539c148')) {
      api.createRecord('3539c148', component.options)
    } else {
      api.reload('3539c148', component.options)
    }
    module.hot.accept("./AccountDashboardInformation.vue?vue&type=template&id=3539c148&", function () {
      api.rerender('3539c148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountDashboard/AccountDashboardInformation.vue"
export default component.exports